'use client'

import { useCallback, useEffect } from 'react'

import { usePwaStore } from '@/stores/pwa-store'
import { BeforeInstallPromptEvent } from '@/types/global'

const PwaInstallationInitialization = () => {
  const { setPromptEvent, clearPromptEvent, setIsWaitingForBeforeInstall, setIsInstallableByPrompt, setIsInstalling } =
    usePwaStore()

  const handleBeforeInstallPrompt = useCallback(
    (event: BeforeInstallPromptEvent) => {
      event.preventDefault()
      setPromptEvent(event)
      setIsInstallableByPrompt(true)
      setIsWaitingForBeforeInstall(false)
    },
    [setPromptEvent, setIsInstallableByPrompt, setIsWaitingForBeforeInstall],
  )

  const handleAppInstalled = useCallback(() => {
    clearPromptEvent()
    setIsInstalling(false)
    // @NOTE: perform a hard refresh on app installed (use case is in some Chromium browser, the browser tabs becomes PWA without reloading the state)
    window.location.reload()
  }, [clearPromptEvent])

  useEffect(() => {
    if (window) {
      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      window.addEventListener('appinstalled', handleAppInstalled)
    }

    // since there is no way to check if the app is really installed while using browser
    // need to set the loading to false
    // the delay is use for waiting for the beforeinstallprompt to trigger and set the
    // loading to false
    setTimeout(() => {
      setIsWaitingForBeforeInstall(false)
    }, 3000)

    return () => {
      if (window) {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
        window.removeEventListener('appinstalled', handleAppInstalled)
      }
    }
  }, [])

  return null
}
PwaInstallationInitialization.displayName = 'PwaInstallationInitialization'

export { PwaInstallationInitialization }
